<template>
  <div class='houseSelect'>
    <div class="menu">
      <div class="title-one active">
        <div class="num">1</div>
        <div class="xuanze">选择</div>
        <div class="font">我家户型</div>
      </div>
      <div class="line"></div>
      <div :class="['title-two', {active: active === 1 }]">
        <div class="num">2</div>
        <div class="xuanze">获取</div>
        <div class="font">整屋设计<img class="icon" src="@/assets/renew/3D.png" alt=""></div>
      </div>
    </div>
    <houseType v-if="active == 0" @next="goRoom"></houseType>
    <roomType v-if="active == 1" :house_id="search.house_id" @gohouse="gohouse"></roomType>
  </div>
</template>

<script>
import houseType from './houseType.vue'
import roomType from './roomType.vue'
export default {
  name: 'houseSelect',
  components:{ 
    houseType,
    roomType
  },
  data() {
    return {
      active: 0,
      search: {
        house_id: ''
      }
    }
  },
  computed:{ },
  watch:{
  },
  created() {
  },
  mounted() {
  },
  methods: {
    goRoom(house_id) {
      this.active = 1
      this.search.house_id = house_id
    },
    gohouse() {
      this.active = 0
    }  
  }
}
</script>
<style lang='less' scoped>
.houseSelect {
  .menu {
    width: 1920px;
    height: 137px;
    background: #F0F0F0;
    display: flex;
    align-items: center;
    justify-content: center;
    .man {
      width: 78px;
      height: 120px;
      margin-right: 89px;
      margin-top: 20px;
    }
    .title-one {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: relative;
      .num {
        width: 30px;
        height: 30px;
        background: #666666;
        color: #fff;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: -5px;
        text-align: center;
        font-size: 24px;
        line-height: 30px;
      }
      .xuanze {
        font-size: 26px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #333333;
        margin-bottom: 12px;
      }
      .font {
        font-weight: 400;
        font-size: 24px;
        color: #4E8B46;
      }
    }
    .line {
      width: 420px;
      height: 2px;
      background: #4E8B46;
      margin: 78px 93px 97px 80px; 
    }
    .title-two {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: relative;
      .num {
        width: 30px;
        height: 30px;
        background: #666666;
        color: #fff;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: 18px;
        text-align: center;
        font-size: 24px;
        line-height: 30px;
      }
      .xuanze {
        padding-right: 45px;
        font-size: 26px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-bottom: 12px;
      }
      .font {
        font-weight: 400;
        font-size: 28px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .icon {
          width: 61px;
          height: 34px;
          margin-left: 4px;
        }
      }
    }
    .active {
      .num {
        background: #4E8B46;
        color: #fff;
      }
      .xuanze {
        color: #4E8B46;
      }
      .font {
        color: #4E8B46;
      }
    }
  }
}
</style>